import { api } from "@/lib/api";

// Geschützte Dateien (PDF-Labels, Packzettel, Rechnungen …) MIT Anmeldung laden und anzeigen.
// Nie Token in URLs: Datei per Authorization-Header als Blob holen und über eine Objekt-URL öffnen.
// Safari/Popup-Blocker: Fenster synchron im Klick öffnen, danach die Blob-URL setzen; ohne Fenster → Download.

const toApiPath = (url) => String(url || "").replace(/^https?:\/\/[^/]+/, "").replace(/^\/api(?=\/)/, "");

async function errorText(e) {
  const data = e?.response?.data;
  if (data instanceof Blob) {
    try { return JSON.parse(await data.text())?.detail || ""; } catch { return ""; }
  }
  return data?.detail || e?.message || "";
}

const saveAs = (url, filename) => {
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "datei.pdf";
  document.body.appendChild(a);
  a.click();
  a.remove();
};

export async function openAuthedFile(url, filename = "datei.pdf", { type = "application/pdf", download = false } = {}) {
  const w = download ? null : window.open("", "_blank");
  if (w) {
    try { w.document.title = filename; w.document.body.innerHTML = '<p style="font-family:sans-serif;color:#475569;padding:24px">Datei wird geladen…</p>'; } catch { /* ignore */ }
  }
  try {
    const r = await api.get(toApiPath(url), { responseType: "blob" });
    const blobUrl = URL.createObjectURL(new Blob([r.data], { type: type || r.data.type }));
    if (w && !w.closed) w.location.href = blobUrl;
    else saveAs(blobUrl, filename);
    setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
  } catch (e) {
    if (w) w.close();
    throw new Error((await errorText(e)) || "Datei konnte nicht geladen werden.");
  }
}

export const labelFilename = (s, retour = false) =>
  `${retour ? "Retourenlabel" : "Label"}_${s.auftragsnummer || "Versand"}_${(retour ? s.retour_tracking_number : s.tracking_number) || s.id}.pdf`.replace(/[^\w.\-äöüÄÖÜß]+/g, "_");
